export default __webpack_public_path__ + "static/media/Group 3184@2x.43db5d19.png";